import { add } from './add'
import { edit } from './edit'
import { getDetails } from './getDetails'
import { getList } from './getList'

const assetLocationResources = {
  getDetails,
  getList,
  add,
  edit,
}

export default assetLocationResources

export type AssetLocation = Awaited<ReturnType<typeof getList>>[number]
export type AssetLocationDetails = Awaited<ReturnType<typeof getDetails>>
export type AddAssetLocationPayload = Parameters<typeof add>[number]
export type EditAssetLocationPayload = Parameters<typeof edit>[number]
